<template>
  <v-container>
    <span v-if="(pmsInfo.sites) && pmsInfo.sites.length > 1">
      <p>Multiple sites have been detected in this PMS. Please select the one you wish to use for activation from the list.</p>
      <v-select
        placeholder="Select a PMS Site"
        :solo="true"
        :items="pmsInfo.sites"
        item-text="name"
        item-value="pmsSiteId"
        v-model="site"
        @change="setSite()"
      ></v-select>
      
    <v-divider></v-divider>
    </span>

    <v-expand-transition>
      <v-alert type="info" v-if="selectedSiteAlreadyLinked">
        This PMS Site has already has synchronzied appointment books with the following OLB systems:
        <ul v-for="acc in selectedSiteLinkedAccounts" :key="acc.pmsSiteId">
          <li>{{acc.platform}} - {{getAccountNameFromCache(acc)}} 
                <v-btn  :to="{ name: 'ManageMh1', params: { sub: $route.params.sub, mh1PracticeId: acc.accountId }}" small >Manage</v-btn>
            </li>
          <ul>
            <li>Synchronized Appointment Books: {{acc.olbBooks.length}}</li>
            
            <li>Open in {{acc.platform}}<v-btn
              icon
              :href="getExternalManageURL(acc)"
              target="_blank"
            >
              <v-icon  x-small class="pl-1 mt-n1">mdi-open-in-new</v-icon>
            </v-btn></li>
          </ul>
        </ul>
      </v-alert>
    </v-expand-transition>

    <v-divider></v-divider>

    <v-tabs v-if="selectedSite.pmsSiteId">
      <v-tab>Site Details</v-tab>
      <v-tab-item>
        <v-simple-table>
          <template>
            <tbody>
              <tr v-if="selectedSite.name">
                <td>Site Name</td>
                <td>{{selectedSite.name || selectedSite.pmsSiteId}}</td>
              </tr>
              <tr v-if="selectedSite.address">
                <td>Address</td>
                <td>{{selectedSite.address.addressLine1}} {{selectedSite.address.addressLine2}} {{selectedSite.address.city}} {{selectedSite.address.postcode}} {{selectedSite.address.state}}</td>
              </tr>
              <tr v-if="selectedSite.abbreviation">
                <td>Site Abbreviation</td>
                <td>{{selectedSite.abbreviation}}</td>
              </tr>
              <tr v-if="selectedSite.pmsSiteId">
                <td>Site PMS Internal ID</td>
                <td>{{selectedSite.pmsSiteId}}</td>
              </tr>
              <tr v-if="selectedSite.isInactive">
                <td>Set to Inactive in PMS</td>
                <td>
                  {{selectedSite.isInactive}}
                  <span
                    v-if="selectedSite.inactiveReasons"
                  >{{selectedSite.inactiveReasons.join(", ") || "" }}</span>
                </td>
              </tr>
              <tr v-if="selectedSite.timeZone">
                <td>Time Zone</td>
                <td>{{selectedSite.timeZone}}</td>
              </tr>
              <tr v-if="selectedSite.businessName">
                <td>Business Name</td>
                <td>{{selectedSite.businessName}}</td>
              </tr>
              <tr v-if="selectedSite.abn">
                <td>ABN</td>
                <td>{{selectedSite.abn}}</td>
              </tr>
              <tr v-if="selectedSite.publicContactEmail">
                <td>Contact Email</td>
                <td>{{selectedSite.publicContactEmail}}</td>
              </tr>
              <tr v-if="selectedSite.publicContactPhone">
                <td>Contact Phone</td>
                <td>{{selectedSite.publicContactPhone}}</td>
              </tr>
              <tr
                v-if="selectedSite.siteSupportContact || selectedSite.siteSupportContactEmail || selectedSite.siteSupportContactPhone"
              >
                <td>Support Contact</td>
                <td>{{selectedSite.siteSupportContact}} {{selectedSite.siteSupportContactEmail}} {{selectedSite.siteSupportContactPhone}}</td>
              </tr>
              <tr v-if="selectedSite.website">
                <td>Website</td>
                <td>{{selectedSite.website}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-tab-item>
      <v-tab>Appointment Books</v-tab>
      <v-tab-item>
        <v-simple-table>
          <template>
            <thead>
              <tr>
                <th>Book Name</th>
                <th>Resource</th>
                <th>Internal ID</th>
                <th>Fully Qualified ID</th>
                <th>Is Inactive</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(bi, index) in bookInfoForSite" :key="index">
                <td>{{bi | bookDisplayName }}</td>
                <td>{{bi | resouceDescription}}</td>
                <td>{{bi.book.pmsAppointmentBookId || bi.book.abbreviation}}</td>
                <td>{{bi.book.pmsBookFQId}}</td>
                <td>{{bi.book.isInactive ? "Yes" : "No"}} {{bi.book.inactiveReasons}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";

export default {
  name: "SelectSite",
  props: {
    value: Object,
    pmsInfo: Object,
  },
  data: function () {
    return {
      site: {},
      mh1BaseUri: process.env.VUE_APP_MH1_BASE_URI,
      ccBaseUri: process.env.VUE_APP_CC_BASE_URI,
      selectedSiteLinkedAccounts: [],
      accountNameCache: {},
    };
  },
  created: function () {
    //this.site = this.pmsInfo?.sites[0]?.pmsSiteId ?? {};
    // this is always valid as one feature has to be selected
    this.$emit("step-is-valid", true);

  },
  watch: {
    pmsInfo: {
      handler: function(val, oldVal) {

          const pmsInfo = val;
          console.info(`SelectSite.watch.pmsInfo got ${pmsInfo?.sites?.length ?? 0} oldVal ${oldVal?.sites?.length ?? 0 }`);


        if ((pmsInfo.sites) && pmsInfo.sites.length === 1 ) {
          this.site = pmsInfo.sites[0].pmsSiteId;
          this.setSite();
        } 
      },
      deep: true,
      immediate: true

    }
  },
  methods: {
    setSite: async function () {
      this.selectedSiteLinkedAccounts = [];
      if (this.selectedSite) {
        await this.getSelectedSiteLinkedAccounts();
      }
      this.$emit("input", { ...this.value, selectedSiteId: this.site });
      this.$emit("step-is-valid", true);
    },
    getSelectedSiteLinkedAccounts: async function () {
      if (!this.selectedSite) return [];

      const site = this.selectedSite;

      if (!Object.keys(site).length || !this.value?.links) return [];

      const foundAccs = this.value.links?.accounts.filter((acc) => {
        if (acc.primaryPmsSiteId == site.pmsSiteId) return true;

        const foundBooksById = acc.olbBooks.filter((b) =>
          b.pmsBookFQId.startsWith(site.pmsSiteId + "::")
        );
        if ((foundBooksById?.length ?? 0) > 0) return true;

        const siteAbbrev = site.abbreviation;

        if (!siteAbbrev) return false;
        const foundBooksByAbbrev = acc.olbBooks.filter((b) =>
          b.pmsBookFQId.startsWith(siteAbbrev + "::")
        );
        if ((foundBooksByAbbrev?.length ?? 0) > 0) return true;

        return false;
      });

      console.log("getSelectedSiteLinkedAccounts foundAccs", foundAccs, this.value.links);

      for (const acc of foundAccs) {
        const accNameCache = this.accountNameCache[
          acc.platform + acc.accountId
        ];

        if (accNameCache) {
          //acc.accountName = accNameCache;
        } else {
          const accName = await this.getPlatformAccountName(acc);

          //acc.accountName = accName;
          this.accountNameCache[acc.platform + acc.accountId] = accName;
        }
      }

      this.selectedSiteLinkedAccounts = foundAccs;
    },
    getResourcesForBook: function (book) {
      return book.pmsResourceIds
        ?.map((bookResourceId) =>
          this?.pmsInfo?.resources?.find(
            (r) => r.pmsResourceId == bookResourceId
          )
        )
        .filter((n) => n);
    },
    getNamesForBook: function (book) {
      const bookResourceIds = book.pmsResourceIds;
      const resources = bookResourceIds
        ?.map((bookResourceId) =>
          this?.pmsInfo?.resources?.find(
            (r) => r.pmsResourceId == bookResourceId
          )
        )
        .filter((n) => n);

      if (!resources) {
        return book.pmsAppointmentBookId;
      }
      const names = resources?.map((r) => {
        return `${r.title ?? ""} ${r.name ?? ""} ${r.firstName ?? ""} ${
          r.surname ?? ""
        } ${r.abbreviation ? " - " + r.abbreviation : ""}`;
      });
      return names?.join(", ");
    },
    getPlatformAccountName: async function (acc) {
      console.log("getPlatformAccountName", acc);
      switch (acc?.platform?.trim()?.toLowerCase() ?? "") {
        case "mh1": {
          try {
            const mh1Details = await API.graphql(
              graphqlOperation(queries.getMh1PracticeDetails, {
                practiceId: Number(acc.accountId),
              })
            );
            if (!mh1Details?.data?.getMh1PracticeDetails?.name) {
              this.handleResponseError("Get Mh1 Practice Details", mh1Details);
              return "";
            }

            return mh1Details.data.getMh1PracticeDetails.name;
            //return mh1Details.data.getMh1PracticeDetails.name;
          } catch (err) {
            this.handleResponseError("Get Mh1 Practice Details", err);
          }
          return "";
          break;
        }
        default: {
          return acc?.platform;
          break;
        }
      }
    },
    getExternalManageURL: function (acc) {
      switch (acc.platform?.toLowerCase() ?? "") {
        case "mh1":
          return `${this.mh1BaseUri}/practice/show/${acc.accountId}`;
        case "gbs":
          return `${this.ccBaseUri}/practice/show/${acc.accountId}`;
        default:
          return "";
      }
    },
    async handleResponseError(operationDescription, response) {
      console.log("handleResponseError", operationDescription, response);
      const notifyResult = await this.$dialog.notify.error(
        operationDescription,
        {
          position: "top-right",
          timeout: 5000,
          actions: [{ text: "Info", "x-small": true, color: "secondary" }],
        }
      );

      if (notifyResult == "Info") {
        this.$dialog.error({
          text: JSON.stringify(response?.errors || response),
          title: operationDescription,
          icon: "mdi-error",
        });
      }
    },
    getAccountNameFromCache(acc) {
      return this.accountNameCache[acc.platform + acc.accountId];

    }
  },
  filters: {
    bookDisplayName: function (bi) {
      return (
        bi.book.name ??
        bi.resources
          ?.map((r) => {
            if (r.name) {
              return `${r.title ?? ""} ${r.name ?? ""}`;
            } else {
              return `${r.title ?? ""} ${r.firstName ?? ""} ${r.surname ?? ""}`;
            }
          })
          ?.join(", ") ??
        ""
      );
    },
    resouceDescription: function (bi) {
      return (
        bi.resources
          ?.map((r) =>
            [r.position ?? "", r.resourceType ?? ""]
              .filter((a) => a)
              .join(" - ")
          )
          ?.join(", ") ?? ""
      );
    },
  },
  computed: {
    selectedSite: function () {
      return this.pmsInfo?.sites?.find((s) => s.pmsSiteId == this.site) ?? {};
    },
    selectedSiteAlreadyLinked: function () {
      return (this.selectedSiteLinkedAccounts?.length ?? 0) > 0;
    },
    /*
    selectedSiteAlreadyLinked: function () {
      const otherSiteLinked = this.selectedSiteLinkedAccounts;
      otherSiteLinked.map(acc => this.getPlatformAccountName(acc));
      return (otherSiteLinked?.length ?? 0) > 0 ? true : false;
    },
    selectedSiteLinkedAccounts: function () {
      if (!this.selectedSite) return [];

      const site = this.selectedSite;

      if (!Object.keys(site).length || !this.value?.links) return [];

      return this.value.links?.accounts.filter((acc) => {
        if (acc.preferredPmsSiteId == site.pmsSiteId) return true;

        const foundBooksById = acc.olbBooks.filter((b) =>
          b.pmsBookFQId.startsWith(site.pmsSiteId + "::")
        );
        if ((foundBooksById?.length ?? 0) > 0) return true;

        const siteAbbrev = site.abbreviation;

        if (!siteAbbrev) return false;
        const foundBooksByAbbrev = acc.olbBooks.filter((b) =>
          b.pmsBookFQId.startsWith(siteAbbrev + "::")
        );
        if ((foundBooksByAbbrev?.length ?? 0) > 0) return true;

        return false;
      });
    },
    */
    bookInfoForSite: function () {
      const resourcesForBook = this.selectedSite?.appointmentBooks?.map((b) => {
        const resourcesForBook = b.pmsResourceIds
          ?.map((bookResourceId) =>
            this?.pmsInfo?.resources?.find(
              (r) => r.pmsResourceId == bookResourceId
            )
          )
          .filter((n) => n);

        return {
          book: b,
          resources: resourcesForBook,
        };
      });
      return resourcesForBook;
    },
  },
};
</script>